import React from 'react';
import { useUser } from '~/providers/user';
import { useContentLibrary } from '../../../providers/content_library_provider';
import DocumentSearchTable from './documentSearchTable';
import OldDocumentSearchTable from './oldDocumentSearchTable';
const DocumentSearch = () => {
    const { useNewView } = useUser();
    const { oldQueryInfo, oldSearchedDocuments, searchedDocuments, queryInfo } = useContentLibrary();
    if (!useNewView) {
        if (!oldSearchedDocuments || !oldQueryInfo)
            return React.createElement(React.Fragment, null);
        return React.createElement(OldDocumentSearchTable, { documents: oldSearchedDocuments, queryInfo: oldQueryInfo });
    }
    if (!searchedDocuments || !queryInfo)
        return React.createElement(React.Fragment, null);
    return React.createElement(DocumentSearchTable, { documents: searchedDocuments, queryInfo: queryInfo });
};
export default DocumentSearch;
